import { useEffect } from 'react';
import { KEY_RECOIL } from '@/shared/config';
import { selectIsEmptyData, useReportStore } from '@/entities/report';

/**
 * Tracks whether the HR summary tab has any recorded data and clears the strip selection when it does not. Reads isEmptyData from the report store under the TAB_6 key and, in an effect, sets the selected strip to null whenever that flag turns true.
 *
 * @returns An object carrying isEmptyData.
 */
const useWrapReport = () => {
  const keyRecoil = KEY_RECOIL.HR_SUMMARY;
  const isEmptyData = useReportStore(selectIsEmptyData(keyRecoil));
  const setSelectedStripAction = useReportStore((s) => s.actions.setSelectedStrip);
  /**
   * Replaces the strip currently selected in the HR summary tab. Forwards the value, or an updater for it, to the report store action bound to the TAB_6 key.
   *
   * @param v - The strip to select, or an updater receiving the previously selected strip.
   * @returns Nothing.
   */
  const setSelectedStrip = (v: Parameters<typeof setSelectedStripAction>[1]) =>
    setSelectedStripAction(keyRecoil, v);

  useEffect(() => {
    if (isEmptyData) {
      setSelectedStrip(null);
    }
  }, [isEmptyData]);

  return {
    isEmptyData,
  };
};

export default useWrapReport;
